import type { TFunction } from 'i18next';
import type { AssetCommandConsoleEntry } from '../types';

export type ConsoleTone =
  | 'outbound'
  | 'inbound'
  | 'waiting'
  | 'success'
  | 'warning'
  | 'danger'
  | 'neutral';

export function consoleEntryTone(entry: AssetCommandConsoleEntry): ConsoleTone {
  switch (entry.kind) {
    case 'send':
      return 'outbound';
    case 'callResult':
      return 'inbound';
    case 'waiting':
      return 'waiting';
    case 'completed': {
      if (entry.outcome === 'rejected' || entry.outcome === 'notSupported') {
        return 'warning';
      }
      if (entry.outcome === 'callError') {
        return 'danger';
      }
      return 'success';
    }
    case 'callError':
    case 'infraError':
      return 'danger';
    case 'timeout':
      return 'warning';
    default:
      return 'neutral';
  }
}

export function consoleDirectionLabel(
  entry: AssetCommandConsoleEntry,
  t: TFunction<'assets'>,
): string | null {
  switch (entry.kind) {
    case 'send':
      return t('detail.commands.console.directionOutbound');
    case 'callResult':
    case 'callError':
      return t('detail.commands.console.directionInbound');
    case 'waiting':
      return t('detail.commands.console.directionWaiting');
    case 'timeout':
      return t('detail.commands.console.directionTimeout');
    case 'completed': {
      if (entry.outcome === 'rejected' || entry.outcome === 'notSupported') {
        return t('detail.commands.console.directionWarning');
      }
      if (entry.outcome === 'callError') {
        return t('detail.commands.console.directionFailed');
      }
      return t('detail.commands.console.directionSuccess');
    }
    case 'infraError':
      return t('detail.commands.console.directionError');
    default:
      return null;
  }
}

export function consoleToneColor(tone: ConsoleTone): string {
  switch (tone) {
    case 'outbound':
      return '#5eead4';
    case 'inbound':
      return '#93c5fd';
    case 'waiting':
      return '#fbbf24';
    case 'success':
      return '#4ade80';
    case 'warning':
      return '#fb923c';
    case 'danger':
      return '#f87171';
    case 'neutral':
    default:
      return '#a3a3a3';
  }
}

export function shouldCollapsePayload(
  payload: Record<string, unknown> | undefined,
): boolean {
  if (!payload) {
    return false;
  }
  try {
    return JSON.stringify(payload).length > 280;
  } catch {
    return true;
  }
}
